export function trimSlashes(
  path: string,
  position: 'leading' | 'trailing' | 'both' = 'both'
) {
  switch (position) {
    case 'leading':
      return path.replace(/^\/+/, '');
    case 'trailing':
      return path.replace(/\/+$/, '');
    case 'both':
      return path.replace(/^\/+|\/+$/g, '');
  }
}
